import { createRouter, createWebHistory } from 'vue-router'
import { jwtDecode } from 'jwt-decode'
import store from '../store'
import MainView from '../views/MainView.vue'
import AdminRoutes from './admin.routes'
import ClientRoutes from './client.routes'

const routes = [
  ...AdminRoutes,
  ...ClientRoutes,
  /* public site options can be placed here */
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('@/views/WelcomeView'),
    meta: { public: true }
  },
  {
    path: '/',
    name: 'home',
    component: MainView,
    meta: { public: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

function getUserRole() {
  const token = store.getters['stateUser/accessToken']
  if (!token) return null
  try {
    const decoded = jwtDecode(token)
    return decoded.role || decoded['custom:role'] || null
  } catch (err) {
    return null
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.public) return next()

  const role = getUserRole()

  if (!role) {
    // Not authenticated at all — send to the entry point rather than
    // silently rendering a protected view.
    return next({ name: 'home' })
  }

  // Admins bypass all route-level role restrictions.
  if (role === 'admin') return next()

  const allowedRoles = to.meta.roles || []
  if (allowedRoles.includes(role)) return next()

  // Authenticated, but not permitted for this specific route — redirect
  // to their own home rather than showing a dead end.
  return next({ name: 'client' })
})

export default router